import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store/store";
import { ref, onMounted, onUpdated } from "vue";
import AdminInfoDataService from "@/services/AdminInfoDataService";
import ResponseData from "@/types/ResponseData";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const newUrl = ref("");

/** 初期表示設定 */
onMounted(function () {
  if (store.getters.isNewsFlg) {
    document.getElementById("divMenu").style.width = "60%";
    document.getElementById("divMenu").style.float = "right";
  } else {
    document.getElementById("divMenu").style.width = "100%";
  }
});

onUpdated(function () {
  if (store.getters.isNewsFlg) {
    document.getElementById("divMenu").style.width = "60%";
    document.getElementById("divMenu").style.float = "right";
  } else {
    document.getElementById("divMenu").style.width = "100%";
  }

  var tableHeight = 0;
  var dataHeight = document.getElementById("ulMenu")?.clientHeight;
  if (dataHeight != 0) {
    tableHeight = document.getElementById("divMenu")?.clientHeight;
    if (dataHeight > tableHeight) {
      document.getElementById("divMenu").style.overflow = "";
    } else {
      document.getElementById("divMenu").style.overflowY = "hidden";
    }
  }
});

const toggleSubMainMenuOpen = (mordalMainItem: any) => {
  var allMainMenu = "";
  if (store.getters.showedMenuList == "") {
    store.dispatch("setShowedMenuList", mordalMainItem.id);
  } else if (!store.getters.showedMenuList.includes(mordalMainItem.id)) {
    allMainMenu = store.getters.showedMenuList + mordalMainItem.id;
    store.dispatch("setShowedMenuList", allMainMenu);
  } else {
    // 既に開いたメニューの場合、閉じるため(空白で交換する)
    allMainMenu = store.getters.showedMenuList
      .split(mordalMainItem.id)
      .join("");
    store.dispatch("setShowedMenuList", allMainMenu);
  }
};

/** ポップアップウィンドウを開く関数 */
const openWindow = (item: { id: string; name: any; url: string; }) => {
  if(item.id == "ST0108"){
    store.dispatch("setShowPageTitle", item.name);
    store.dispatch("setShowPage", item.url);
  }else{
    // Parts Order Total (MSIL)サブメニューの場合、
    if(item.id == "SM0198"){
      if (item.url && ["1000","1235"].includes(store.getters.stationCode)) {
        item.url = "DST01152";
      }else{
        item.url = "PMSIL";
      }
    }
    if (item.url) {
      newUrl.value = `${process.env.VUE_APP_ONPREMISE_URL_DOMAIN}main/TO_V2.asp?DEST=${item.url}&CTLNO=${store.getters.loginNumber}`;
      window.open(newUrl.value, "_blank");
    }
  }
  // access log append for alternative login
  if(store.state.isAltLogin == true){
    store.dispatch("setAccessLog",{mainMenuCode:item.id, accessTime: new Date()});
  }
};

/** ニュース管理画面表示 */
const openNewsFunction = (url: any) => {
  if(url == 'NewsMailMaintenance'){
    store.dispatch("setShowPage", url);
  }else{
    const data = {
      userId: store.getters.cognitoUserName,
      destCode: store.getters.mainMenuCode,
    };
    AdminInfoDataService.getUserByUserID(data).then((response: ResponseData) => {
      if (response.data == 0) {
        alert("You don't have permission to access this page.");
      } else {
        store.dispatch("setShowPage", url);
      }
    });
  }
  // access log append for alternative login
  if(store.state.isAltLogin == true){
    store.dispatch("setAccessLog",{mainMenuCode:store.getters.mainMenuCode, accessTime: new Date()});
  }
};

const __returned__ = { newUrl, toggleSubMainMenuOpen, openWindow, openNewsFunction, store }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})